import React, { memo } from 'react'
import PropTypes from 'prop-types'
import ListView from './ClinicsList'
import { Typography } from 'antd'
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import useClinics from '../hooks/useClinics'
import { faClinicMedical } from '@fortawesome/free-solid-svg-icons'
import PageHeader from '../../../reusable-components/PageHeader'

const { Title, Text } = Typography

const ClinicsWrapper = () => {
  const { loading, viewData, createRecord, editRecord, deleteRecord, refreshView, handleSearch } = useClinics()

  return (
    <ContainerCard bodyStyle={{ padding: 0 }}>
      <PageHeader title='Facilities Management' icon={faClinicMedical} />
      <ListView
        loading={loading}
        data={viewData}
        createRecord={createRecord}
        editRecord={editRecord}
        deleteRecord={deleteRecord}
        refreshView={refreshView}
        handleSearch={handleSearch}
      />
    </ContainerCard>
  )
}

ClinicsWrapper.propTypes = {
  loading: PropTypes.bool,
  viewData: PropTypes.array,
  createRecord: PropTypes.func,
  editRecord: PropTypes.func,
  deleteRecord: PropTypes.func,
  refreshView: PropTypes.func,
  handleSearch: PropTypes.func
}

export default memo(ClinicsWrapper)
